function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNeutral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "7z3kkm71xa"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 224",
    style: {
      fill: "#777"
    },
    d: "M0 0h16v16H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 7",
    style: {
      clipPath: "url(#7z3kkm71xa)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 4",
    d: "M8 0a8 8 0 1 0 8 8 8 8 0 0 0-8-8M3.686 6.633a1.219 1.219 0 1 1 1.219 1.22 1.219 1.219 0 0 1-1.219-1.22M9.8 11.792H6.2a.567.567 0 0 1 0-1.134h3.6a.567.567 0 1 1 0 1.134m1.3-3.94a1.219 1.219 0 1 1 1.219-1.219A1.219 1.219 0 0 1 11.1 7.852",
    style: {
      fill: "#777"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNeutral);
export default __webpack_public_path__ + "static/media/icon-neutral.2bdd5707c2e89caf6d7f1f26db45c8e6.svg";
export { ForwardRef as ReactComponent };